import { BASE_API_URL } from "../../config/Api";
import { AUDITSTAMPING_LIST, INSERT_AUDITSTAMPING, LOGIN, LOGOUT, REQ_USER, UPDATE_AUDITSTAMPING } from "./ActionType";

export const login = (data) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/authenticate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const resData = await res.json();
    if (resData.token) localStorage.setItem("token", resData.token);

    dispatch({ type: LOGIN, payload: resData });
    return resData;
  } catch (error) { }
};

export const currentUser = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/getUserProfile`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const resData = await res.json();

    if (resData.loginId) localStorage.setItem("loginId", resData.loginId);
    if (resData.role) localStorage.setItem("role", resData.role);
    if (resData.username) localStorage.setItem("username", resData.username);
    dispatch({ type: REQ_USER, payload: resData });
  } catch (error) { }
};

export const logoutAction = () => async (dispatch) => {
  localStorage.clear();
  dispatch({ type: LOGOUT, payload: null });
  dispatch({ type: REQ_USER, payload: null });
};



export const insertAuditStamping = (username, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/insert-audit-stamping?username=${username}`, {
      method: "POST", headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
    );

    const resData = await res.json();

    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: INSERT_AUDITSTAMPING, payload: resData });
      return { success: true, data: resData };
    } else {
      return {
        success: false, error: resData?.statusDesc || `HTTP error: ${res.status}`,
      };
    }
  } catch (error) {
    console.error("Error in insertAuditStamping:", error);
    return {
      success: false, error: error.message || "Network error",
    };
  }
};


export const updateAuditStamping = (username, logoutType, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/update-audit-stamping`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        username: username,
        logoutType: logoutType
      })
    });

    const resData = await res.json();

    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: UPDATE_AUDITSTAMPING, payload: resData });
      return { success: true, data: resData };
    } else {
      return {
        success: false, error: resData?.statusDesc || `HTTP error: ${res.status}`,
      };
    }
  } catch (error) {
    console.error("Error in updateAuditStamping:", error);
    return {
      success: false, error: error.message || "Network error",
    };
  }
};

export const auditStampingList = (loginId, fromDate, toDate,token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/audit-stamping-list?loginId=${loginId}&fromDate=${fromDate}&toDate=${toDate}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: AUDITSTAMPING_LIST, payload: resData });
  } catch (error) {}
};
